export default {"src":"/_next/static/media/arrow-inverted.e355f1cc.svg","height":6,"width":66,"blurWidth":0,"blurHeight":0};